import React from 'react'

const Footer = () => {
    return (
        <footer className="footer">
            <p>By <a href="https://github.com/N-Nikolaev">n_nikolaev</a></p>
        </footer>
    )
}

export default Footer
